import React from 'react'
import { iconsDetailsProyect } from '../../../../assets/icons/detailsProject'


export const TabOption = ({ tabs = [], selectIteam = 0 }) => {
    return (
        <div className="w-full ">
            <div className="w-full h-[55px] relative">
                <div className="w-full h-full grid grid-cols-3">
                    {tabs.map((iteam, index) => (
                        <div key={`${index}-iteam-header`} className="flex justify-center items-center gap-1 relative h-full w-full">
                            <div
                                className={`w-[20px] md:w-[24px] h-[20px] md:h-[24px] rounded-full border-[1px] text-[10px] ${selectIteam === index ? "border-[#1677FF]" : "border-[#9A9A9A]"
                                    }  flex justify-center items-center overflow-hidden`}
                            >
                                <span className={` ${selectIteam === index ? " text-[#1677FF]" : " text-[#9A9A9A]"}`}>0{index + 1}</span>
                            </div>
                            <div className={`${selectIteam === index && "font-semibold"}`}>
                                <span className='text-[10px] md:text-[12px]'>{iteam}</span>
                            </div>
                            <div className={`absolute z-10 h-[3px] w-full ${selectIteam === index && "bg-[#1677FF]"} bottom-0`}></div>
                        </div>
                    ))}
                </div>
                <img className="w-full h-full absolute z-10 top-0" src={iconsDetailsProyect.headerConclued} alt="header" />
            </div>
        </div>
    )
}
